export default __webpack_public_path__ + "a0fcac97c2521b403e3543a1a47c988b.png";